import { mergeGiftFinderConfig } from '../content/siteCopyHelpers';
import { GIFT_FINDER_DEFAULTS } from '../content/giftFinderDefaults';

export { GIFT_FINDER_DEFAULTS };

export function getGiftFinderConfig(storeCopy) {
  const gf = storeCopy?.gift_finder;
  return mergeGiftFinderConfig(gf);
}

export function isGiftFinderEnabled(storeCopy) {
  return getGiftFinderConfig(storeCopy).enabled;
}

/** @param {'home'|'shop'|'nav'|'footer'} placement */
export function isGiftFinderLinkVisible(storeCopy, placement) {
  const cfg = getGiftFinderConfig(storeCopy);
  if (!cfg.enabled) return false;
  switch (placement) {
    case 'home':
      return cfg.show_on_home;
    case 'shop':
      return cfg.show_on_shop;
    case 'nav':
      return cfg.show_in_nav;
    case 'footer':
      return cfg.show_in_footer;
    default:
      return false;
  }
}

export function giftFinderLinkLabel(storeCopy, placement) {
  const cfg = getGiftFinderConfig(storeCopy);
  switch (placement) {
    case 'home':
      return cfg.home_button_label;
    case 'shop':
      return cfg.shop_button_label;
    case 'nav':
    case 'footer':
      return cfg.nav_label;
    default:
      return cfg.nav_label;
  }
}
